import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ProductCarouselSection from 'Containers/HomePage/ProductCarouselSection';
import { fetchBySlugs } from 'Redux/ducks/algolia-calls';


const messages = defineMessages({
  asterixProducts: {
    id: 'AsterixProducts.title',
    defaultMessage: 'Asterix & Obelix Omnibuses',
  },
  seoBlurb: {
    id: 'AsterixProducts.seoBlurb',
    defaultMessage: 'Welcome to Gaul! Join Asterix, Obelix, and their village of fearless Gauls as they outwit Romans, explore new lands, and serve up epic laughs. The comic omnibus editions collect their legendary escapades into one unbeatable collection — perfect for new readers and long time fans! Ready to join the resistance?',
  },
});

const AsterixProducts = () => {
  const fetchHits = async () => {
    const results = await fetchBySlugs([['asterix-omnibus-vol-1', 'asterix-omnibus-vol-2', 'asterix-omnibus-vol-3']]);

    return results?.[0] || [];
  };

  const { formatMessage } = useIntl();
  return (
    <ProductCarouselSection
      sectionCss="AsterixProducts"
      seoBlurb={formatMessage(messages.seoBlurb)}
      title={formatMessage(messages.asterixProducts)}
      hitCardNameTag="h3"
      slidesToShow={3}
      lgSize={4}
      fetchHits={fetchHits}
      headingTag="h1"
    />
  );
};

export default AsterixProducts;
